import Swiper from "swiper";
import { Mousewheel, Navigation } from "swiper/modules";
import "swiper/swiper-bundle.css";

class NumericCardsSwiper {
  constructor(el) {
    this.el = el;
    this.swiper = this.el.querySelector(".swiper");

    if (this.swiper) {
      new Swiper(this.swiper, {
        spaceBetween: 11,
        slidesPerView: 1.6,
        loop: false,
        grabCursor: true,
        direction: "horizontal",
        mousewheel: {
          enabled: true,
          forceToAxis: true,
        },

        breakpoints: {
          667: {
            slidesPerView: 2.6,
          },
          768: {
            slidesPerView: 2.3,
            spaceBetween: 16,
          },
          992: {
            slidesPerView: 3.3,
            spaceBetween: 16,
          },
          1440: {
            slidesPerView: 4,
            spaceBetween: 16,
          },

        },
        navigation: {
          prevEl: this.el.querySelector(".areas-sec .swiper-arrows .swiper-arrows__prev"),
          nextEl: this.el.querySelector(".areas-sec .swiper-arrows .swiper-arrows__next"),
        },
        modules: [Navigation, Mousewheel],
      });
    }
  }
}

function initNumericCardsSwiper() {
  const sliders = document.querySelectorAll(".areas-sec");
  for (let slider of sliders) {
    new NumericCardsSwiper(slider);
  }
}

initNumericCardsSwiper();
